var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__clip0_2289_3574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 0H16C7.163 0 0 7.163 0 16v32c0 8.837 7.163 16 16 16h32c8.837 0 16-7.163 16-16V16c0-8.837-7.163-16-16-16z",
    fill: "url(#logo_svg__paint0_linear_2289_3574)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo_svg__clip1_2289_3574)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.017 20.188a1.318 1.318 0 00-1.316 1.313v9.975c0 .591-.132 1.05.263 1.378l7.433 7.416a1.355 1.355 0 001.908-.066 1.289 1.289 0 00.066-1.9l-6.973-6.956V21.5a1.318 1.318 0 00-1.316-1.312h-.065zM8.468 28c-1.513 0-1.842.984-1.052 2.166l4.6 6.562a1.306 1.306 0 002.3 0l4.6-6.562c.789-1.116.395-2.166-1.052-2.166h-2.96A17.534 17.534 0 0131.94 14.284c8.354 0 17.76 7.875 17.76 17.587a17.9 17.9 0 01-17.826 17.784 17.476 17.476 0 01-14.143-7.416 1.831 1.831 0 00-2.5-.591 1.72 1.72 0 00-.329 2.559A21 21 0 1031.951 11c-11.511 0-18.747 7.416-20.655 17H8.467h.001z",
    fill: "#fff"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__clip0_2289_3574"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h64v64H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__clip1_2289_3574"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(7 11)",
    d: "M0 0h46v42H0z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "logo_svg__paint0_linear_2289_3574",
    x1: 32,
    y1: 0,
    x2: 32,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BD922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BB01B"
  })))));
}
export default SvgLogo;